import { useSelector } from "react-redux";
import { Navigate } from "react-router-dom";
import Router from "../../const/router";
import LoginForm from "../forms/login-form";

const Admin = () => {
  const { isLoged } = useSelector((state) => state.auth);

  return <>{isLoged ? <Navigate to={Router.ADMIN_SERVICES} /> : <LoginForm />}</>;
};

export default Admin;
